import { Outlet } from "react-router-dom";
import { type ReactNode } from "react";
import { EnergyAdvisorPresentationProvider } from "./context";

/**
 * Outermost element for every `/energy-advisor/*` route. Owns the
 * presentation-mode context for the entire subtree. Fonts are
 * global app-wide; nothing else to scope here.
 *
 * When `children` is provided (Plan 01 single-route form), renders them
 * directly inside the provider. When omitted (Plan 02+ nested-route form),
 * falls back to `<Outlet />` so the router can mount sub-routes.
 */
export function EnergyAdvisorRouteWrapper({ children }: { children?: ReactNode }) {
  return (
    <EnergyAdvisorPresentationProvider>
      {children ?? <Outlet />}
    </EnergyAdvisorPresentationProvider>
  );
}
